function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import template from './usage.bar.chart.html';
import UsageChartHelper from './usage.chart.helper';
import { i18n } from 'invision-core';
import LocaleKeys from '../../../../locales/keys';
var UsageBarChartController = /*#__PURE__*/function () {
  function UsageBarChartController() {
    _classCallCheck(this, UsageBarChartController);
  }
  return _createClass(UsageBarChartController, [{
    key: "$onChanges",
    value: function $onChanges() {
      this.maximumBalance = this.maximumBalance === undefined || this.maximumBalance === null ? 0 : this.maximumBalance;
      this.usageWidth = this.calculatePercentage(this.maximumBalance);
      this.color = UsageChartHelper.getStyleByUsage(this.usageWidth, this.unlimited);
      this.totalUsagePosition = this.positionTotalUsageMarker(this.maximumBalance);

      //TO Be CONSUMED: When we have the ability to cap individual accounts by API.
      //const maximumBalance = this.shared? this.individualInitialBalance() : this.maximumBalance;
      //const ratio = this.calculatePercentage(maximumBalance);
    }
  }, {
    key: "positionTotalUsageMarker",
    value: function positionTotalUsageMarker(value) {
      if (!this.unlimited) {
        var ratio = value > 0 && this.sharedBalanceConsumed ? this.sharedBalanceConsumed / value * 100 : 0;
        ratio = Math.min(Math.max(ratio, 0), 100);
        return "".concat(ratio, "%");
      } else {
        return '100%';
      }
    }
  }, {
    key: "calculatePercentage",
    value: function calculatePercentage(value) {
      if (!this.unlimited && value > 0) {
        return Math.min(Math.max(this.subscriberUsage / value * 100, 0), 100);
      } else {
        return 100;
      }
    }

    /* //TO Be CONSUMED: When we have the ability to cap individual accounts by API.
    this.individualInitialBalance = () => {
        return this.shared.length > 0 ? this.initialBalance / this.shared.length : 0;
    };*/
  }, {
    key: "displayUsageDetails",
    value: function displayUsageDetails() {
      this.unitOfMeasure = this.unitOfMeasure.toUpperCase();
      if (!this.unlimited) {
        return "".concat(this.subscriberUsage, " ").concat(this.unitOfMeasure, " / ").concat(this.maximumBalance, " ").concat(this.unitOfMeasure);
      } else {
        return "".concat(this.subscriberUsage, " ").concat(this.unitOfMeasure, " / ").concat(i18n.translate(LocaleKeys.UNLIMITED));
      }
    }
  }]);
}();
export default {
  controller: UsageBarChartController,
  controllerAs: 'UsageBarChartController',
  bindings: {
    maximumBalance: '<',
    name: '<',
    subscriberUsage: '<',
    sharedBalanceConsumed: '<',
    shared: '<',
    unitOfMeasure: '<',
    unlimited: '<'
  },
  template: template
};